import {
	IFileErrors,
	IFileTypeConfig,
} from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';

export class FileValidation {
	constructor(private fileTypesConfig: IFileTypeConfig) {
		this.fileTypesConfig = fileTypesConfig;
	}

	getFileValidationErrors(file: File): Partial<IFileErrors> {
		const extension = file.name.split('.').pop()?.toLowerCase();
		let fileType: string;

		Object.keys(this.fileTypesConfig).forEach(key => {
			if (this.extensionSupported(key, extension)) {
				fileType = key;
			}
		});

		if (!fileType) {
			return {
				formatError: this.formatError(extension),
			};
		} else if (this.fileTooBig(file, fileType)) {
			return {
				sizeExceeded: this.sizeError(fileType),
			};
		}

		return {};
	}

	getAcceptedFileExtensions() {
		let acc = [];
		Object.values(this.fileTypesConfig).forEach(
			item => (acc = acc.concat(item.supportedFormatsList))
		);
		return acc;
	}

	getNiceFormattedFileTypes(): string {
		return this.getAcceptedFileExtensions().join(', ').toUpperCase();
	}

	private extensionSupported(key: string, extension: string): boolean {
		return this.fileTypesConfig[key].supportedFormatsList.includes(extension);
	}

	private fileTooBig(file: File, fileType: string): boolean {
		return file.size / 1024 / 1024 > this.fileTypesConfig[fileType].maxSize;
	}

	private sizeError(fileType: string): string {
		return `<b>File is too big.</b> Maximum size for ${fileType} files is ${this.fileTypesConfig[fileType].maxSize} MB`;
	}

	private formatError(extension: string) {
		return `<b>File type ${extension} isn't supported. Allowed file formats:</b> ${this.getNiceFormattedFileTypes()}`;
	}
}
